<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row no-gutters>
      <v-text-field
        filled
        label="Nom de l'évènement"
        class="no-before"
        :value="name"
        @change="v => $emit('update:name', v)"
        :rules="[
          v => !!v || 'Un nom est requis',
          v => v != '' || 'Un nom est requis',
          v => v != null || 'Un nom est requis'
        ]"
      ></v-text-field>
    </v-row>
    <v-row no-gutters>
      <j-date-picker
        label="Date de début"
        filled
        icon=""
        class="no-before"
        :value="start"
        @input="v => $emit('update:start', v)"
        required
        :max="end"
      ></j-date-picker>
    </v-row>
    <v-row no-gutters>
      <j-date-picker
        label="Date de fin (optionelle)"
        filled
        icon=""
        class="no-before"
        :value="end"
        @input="v => $emit('update:end', v)"
        :min="start"
      ></j-date-picker>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "EventInput",
  props: {
    name: {
      required: true
    },
    start: {
      required: true
    },
    end: { required: true },
    valid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    }
  }
};
</script>

<style></style>
